(() => {
const RECENT_KEY='biroart_recent';
const SAVED_KEY='biroart_saved';
const read = key => { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (_) { return []; } };
const write = (key,value) => { try { localStorage.setItem(key,JSON.stringify(value)); } catch (_) {} };
const uniqueByUrl = items => items.filter((item,index,self)=>item&&item.url&&self.findIndex(x=>x.url===item.url)===index).slice(0,6);
const escapeHtml = value => String(value||'').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
const card = item => '<a class="saved-card" href="'+escapeHtml(item.url)+'">'+(item.image?'<img src="'+escapeHtml(item.image)+'" alt="'+escapeHtml(item.title)+'" loading="lazy">':'')+'<h3>'+escapeHtml(item.title)+'</h3></a>';

document.querySelectorAll('[data-current-art]').forEach(el => {
 const item={url:el.dataset.url,title:el.dataset.title,image:el.dataset.image};
 if(item.url&&item.title) write(RECENT_KEY,uniqueByUrl([item,...read(RECENT_KEY).filter(x=>x.url!==item.url)]));
 const button=el.querySelector('[data-wishlist-button]');
 if(button){
   const sync=()=>{const saved=read(SAVED_KEY).some(x=>x.url===item.url);button.setAttribute('aria-pressed',String(saved));button.textContent=saved?'♥ Saved':'♡ Save artwork';};
   button.addEventListener('click',()=>{let saved=read(SAVED_KEY);if(saved.some(x=>x.url===item.url))saved=saved.filter(x=>x.url!==item.url);else saved=uniqueByUrl([item,...saved]);write(SAVED_KEY,saved);sync();render();});
   sync();
 }
});

function render(){
 const saved=read(SAVED_KEY), recent=read(RECENT_KEY);
 const savedWrap=document.querySelector('[data-saved-art]'), savedGrid=document.querySelector('[data-saved-grid]');
 if(savedWrap&&savedGrid){savedWrap.hidden=!saved.length;savedGrid.innerHTML=saved.map(card).join('');}
 const recentWrap=document.querySelector('[data-recent-art]'), recentGrid=document.querySelector('[data-recent-grid]');
 if(recentWrap&&recentGrid){recentWrap.hidden=!recent.length;recentGrid.innerHTML=recent.map(card).join('');}
}
render();

document.querySelectorAll('[data-spin-card]').forEach(cardEl=>{
 const button=cardEl.querySelector('[data-spin-button]'), wheel=cardEl.querySelector('[data-spin-wheel]'), result=cardEl.querySelector('[data-spin-result]');
 if(!button||!wheel||!result)return;
 const won=sessionStorage.getItem('biroart_spin')==='1';
 if(won){button.hidden=true;result.hidden=false;}
 button.addEventListener('click',()=>{
   button.disabled=true;wheel.classList.remove('is-spinning');void wheel.offsetWidth;wheel.classList.add('is-spinning');
   setTimeout(()=>{sessionStorage.setItem('biroart_spin','1');button.hidden=true;result.hidden=false;button.disabled=false;},1250);
 });
});
document.querySelectorAll('[data-copy-code]').forEach(button=>button.addEventListener('click',async()=>{
 try{await navigator.clipboard.writeText(button.dataset.copyCode);button.textContent='Copied';}
 catch(_){button.textContent=button.dataset.copyCode;}
}));
})();